export default __webpack_public_path__ + "static/media/logo.0c9c0fd3.svg";